import React from "react";
import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
  return (
    <div style={{ maxWidth: 800, margin: "0 auto", padding: 24 }}>
      <Link to="/" style={backLinkStyle}>← Back to PDF ME</Link>

      <div style={cardStyle}>
        <h1 style={titleStyle}>🔒 Privacy Policy</h1>
        <p style={updatedStyle}>Last updated: February 17, 2026</p>

        <Section title="1. Introduction">
          Welcome to <strong>PDF ME</strong>. Your privacy is important to us. This Privacy Policy explains how we
          collect, use, and protect your information when you use our web application.
        </Section>

        <Section title="2. Information We Collect">
          <strong>PDF ME operates entirely in your browser.</strong> We do not collect, store, or transmit any of
          your personal data or files to external servers.
          <ul style={listStyle}>
            <li>We do <strong>not</strong> upload your PDF files anywhere.</li>
            <li>We do <strong>not</strong> collect personal information (name, email, etc.).</li>
            <li>We do <strong>not</strong> use cookies for tracking purposes.</li>
            <li>All file processing happens locally on your device.</li>
          </ul>
        </Section>

        <Section title="3. Local Storage">
          We may use your browser's local storage to save your editor preferences and auto-save
          your work in progress. This data stays on your device and is never sent to our servers.
        </Section>

        <Section title="4. Third-Party Services">
          Our application does not integrate with third-party analytics, advertising, or tracking
          services. We do not share any data with third parties.
        </Section>

        <Section title="5. Data Security">
          Since all processing is done locally in your browser, your files never leave your device.
          This provides the highest level of privacy and security for your documents.
        </Section>

        <Section title="6. Children's Privacy">
          Our service does not knowingly collect any personal information from children under 13.
          Since we do not collect personal data from any users, this is inherently satisfied.
        </Section>

        <Section title="7. Changes to This Policy">
          We may update this Privacy Policy from time to time. Any changes will be posted on this
          page with an updated revision date.
        </Section>

        <Section title="8. Contact Us">
          If you have any questions about this Privacy Policy, please reach out to us through our
          application's support channels.
        </Section>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: 24 }}>
      <h2 style={sectionTitleStyle}>{title}</h2>
      <p style={textStyle}>{children}</p>
    </div>
  );
}

const backLinkStyle = {
  display: "inline-block",
  marginBottom: 20,
  color: "#FFD700",
  textDecoration: "none",
  fontWeight: 600,
  fontSize: 16,
};

const cardStyle = {
  background: "rgba(255,255,255,0.08)",
  backdropFilter: "blur(10px)",
  borderRadius: 16,
  padding: "36px 40px",
  border: "1px solid rgba(255,255,255,0.15)",
  color: "#fff",
};

const titleStyle = {
  fontSize: 36,
  fontWeight: 800,
  marginBottom: 4,
  background: "linear-gradient(45deg, #ff6b9d, #ffa500)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
};

const updatedStyle = {
  fontSize: 14,
  color: "rgba(255,255,255,0.5)",
  marginBottom: 32,
};

const sectionTitleStyle = {
  fontSize: 20,
  fontWeight: 700,
  color: "#FFD700",
  marginBottom: 8,
};

const textStyle = {
  fontSize: 15,
  lineHeight: "1.7",
  color: "rgba(255,255,255,0.85)",
  margin: 0,
};

const listStyle = {
  marginTop: 10,
  paddingLeft: 20,
  lineHeight: "2",
};
